import React from "react";

const Portfolio = ({ data }) => {
  if (data) {
    var projects = data.projects.map(function (projects, i) {
      var projectVideo = "./videos/portfolio/" + projects.url;
      return (
        <div key={projects.title} className="columns portfolio-item">
          <div className="item-wrap">
            <div onClick={() => activateVideo(i)} className="videoContainer">
              <video id={"video" + i} autoPlay src={projectVideo} muted loop></video>
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{projects.title}</h5>
                  <p>{projects.category}</p>
                </div>
              </div>
              <div className="link-icon">
                <i className="fa fa-link"></i>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  const activateVideo = (index) => {
    const video = document.getElementById("video" + index);
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
      /* Safari */
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) {
      /* IE11 */
      video.msRequestFullscreen();
    }
  };
  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1>Check Out Some of My Works.</h1>

          <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
            {projects}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
